export default __webpack_public_path__ + "static/media/solar.80d61a44.png";